import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';

import * as chanceApi from '../../lib/api/chance';

const [
  LIST_PROJECT_ESTIMATE,
  LIST_PROJECT_ESTIMATE_SUCCESS,
  LIST_PROJECT_ESTIMATE_FAILURE,
] = createRequestActionTypes('tech/LIST_PROJECT_ESTIMATE');

export const listProjectEstimates = createAction(
  LIST_PROJECT_ESTIMATE,
  (id) => id,
);
const listProjectEstimatesSaga = createRequestSaga(
  LIST_PROJECT_ESTIMATE,
  chanceApi.getEstimates,
);

const UNLOAD_ESTIMATE = 'tech/UNLOAD_ESTIMATE';
export const unloadEstimates = createAction(UNLOAD_ESTIMATE);

export function* projectEstimatesSaga() {
  yield takeLatest(LIST_PROJECT_ESTIMATE, listProjectEstimatesSaga);
}

const initialState = {
  estimates: null,
  error: null,
};

const projectEstimates = handleActions(
  {
    [LIST_PROJECT_ESTIMATE_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      estimates: data.list.map((estimate) => ({
        id: estimate.qteUuid,
        qteUuid: estimate.qteUuid,
        prjUuid: estimate.prjUuid,
        qteNo: estimate.qteNo, //견적서 번호
        qteValidDt: estimate.qteValidDt, //유효견적일자
        qtePrice: estimate.qtePrice, //총 견적금액
        qteCondt: estimate.qteCondt, //수금지급조건
        qteTyp: estimate.qteTyp, //견적서 종류
        crtUsr: estimate.crtUsr,
        crtNm: estimate.crtNm,
        crtDt: estimate.crtDt,
        cngUsr: estimate.cngUsr,
        cngNm: estimate.cngNm,
        cngDt: estimate.cngDt,
      })),
      error: null,
    }),
    [LIST_PROJECT_ESTIMATE_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error: error,
    }),
    [UNLOAD_ESTIMATE]: () => initialState,
  },
  initialState,
);

export default projectEstimates;
